/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'components/file-upload': {
    width: 48,
    height: 48,
    viewBox: '0 0 48 48',
    data: '<path pid="0" _fill="#242424" fill-rule="evenodd" d="M41.293 32.293a1 1 0 011.414 0l5 5-1.414 1.414L43 35.414V47h-2V35.414l-3.293 3.293-1.414-1.414 5-5z" clip-rule="evenodd"/><path pid="1" _fill="#242424" fill-rule="evenodd" d="M5 2a1 1 0 011-1h28a1 1 0 01.707.293l8 8A1 1 0 0143 10v18h-2V11h-7a1 1 0 01-1-1V3H7v42h28v2H6a1 1 0 01-1-1V2zm30 2.414L39.586 9H35V4.414z" clip-rule="evenodd"/><path pid="2" _fill="#242424" fill-rule="evenodd" d="M22 19H11v-2h11v2zm15 0H26v-2h11v2zm-15 6H11v-2h11v2zm15 0H26v-2h11v2zm-15 6H11v-2h11v2zm15 0H26v-2h11v2zm-15 6H11v-2h11v2z" clip-rule="evenodd"/>'
  }
})
